<template>
  <Modal v-bind="$attrs" :title="title" scrollable v-on="$listeners">
    <template #contents>
      <label
        v-for="{ id, names, price, tax } in allCourses"
        :key="id"
        class="course"
        :class="{ disabled: selectedIds.find(selectId => selectId === id && id !== -1) }"
      >
        <CheckBox :checked="current == id" type="radio" class="radio" small @click="onSelect(id)" />
        <div class="label">
          <div class="name">{{ $i18n.choice(names) }}</div>
          <div v-if="price" class="price">{{ $n(price, 'currency') }} {{ $t(`tax[${tax}]`) }}</div>
        </div>
      </label>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/molecules/Modal'
import CheckBox from '@/components/atoms/CheckBox'
import { mapGetters } from 'vuex'

export default {
  name: 'CourseSelectModal',
  components: {
    Modal,
    CheckBox,
  },
  props: {
    /** 見出し */
    title: { type: String, default: null },
    /** 選択中のコースID */
    current: { type: Number, default: null },
    /** 選択しているid */
    selectedIds: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters({
      allCourses: 'courses/all',
    }),
  },
  created() {
    this.$store.dispatch('courses/get')
  },
  methods: {
    onSelect(id) {
      /**
       * コースの選択
       * @event select
       * @type {number}
       */
      this.$emit('select', this.allCourses.find(e => e.id === +id))
      this.$emit('close')
    },
  },
}
</script>

<style lang="postcss" scoped>
.course {
  align-items: center;
  border-bottom: 1px solid var(--border-color);
  cursor: pointer;
  display: flex;
  flex: 1 0 auto;
  padding: 16px;

  &.disabled {
    background-color: var(--mostly-white-0);
    pointer-events: none;
  }
}

.radio {
  flex-shrink: 0;
}

.label {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  margin-left: 16px;
  overflow: hidden;
}

.name {
  color: var(--very-dark-gray-1);
  font-weight: 600;
  line-height: 21px;
  margin: -3px 0 -4px;
}

.price {
  font-size: 12px;
  line-height: 16px;
  margin-top: 8px;
}
</style>
